import { render, staticRenderFns } from "./DoctorReestablishModal.vue?vue&type=template&id=13373402&scoped=true"
import script from "./DoctorReestablishModal.vue?vue&type=script&lang=js"
export * from "./DoctorReestablishModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13373402",
  null
  
)

export default component.exports